<template>
  <el-steps :active="active" align-center finish-status="success">
    <el-step title="仮登録(入力)" />
    <el-step title="仮登録(確認)" />
    <el-step title="仮登録(完了)" />
    <el-step title="仮登録完了メール" :icon="active < BoundarySteps.INPUT ? 'el-icon-message' : ''" />
    <el-step title="本登録(入力)" />
    <el-step title="本登録(確認)" />
    <el-step title="本登録(完了)" />
  </el-steps>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { BoundarySteps } from '@/constants/enums'

export default defineComponent({
  name: 'JrBoundaryStep',
  props: {
    active: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      BoundarySteps,
    }
  },
})
</script>
